import React from "react";
import { Link, useParams } from "react-router-dom";
import ReportDetailPage from "../pages/ReportDetailPage";

type Props = {
  isReportView: boolean; // legacy flag (hash)
  reportIdFromHash: string | null;
  authReady: boolean;
  children: React.ReactNode;
};

/**
 * Enkel router för rapport-detalj via hash (nuvarande beteende):
 * - Om hash eller route-param finns, rendera detail-view + “Till Rapporter”-länk
 * - Annars rendera appens shell (children)
 */
export function ReportViewRouter({ isReportView, reportIdFromHash, authReady, children }: Props): JSX.Element {
  const params = useParams<{ id?: string }>();
  const routeReportId = params.id ?? null;

  const activeId = routeReportId || reportIdFromHash;
  const showReport = !!activeId || isReportView;

  if (showReport && activeId) {
    return (
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: 16, color: "var(--text)" }}>
        <div style={{ marginBottom: 12 }}>
          <Link to="/rapporter" title="Till Rapporter" style={{ textDecoration: "none" }}>
            ← Till Rapporter
          </Link>
        </div>

        <ReportDetailPage reportId={activeId} authReady={authReady} />
      </div>
    );
  }

  return <>{children}</>;
}
